module.exports = __webpack_public_path__ + "static/wallpaper4.576eaabc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallpaper4.jpg
// module id = 454
// module chunks = 35783957827783